import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Text from '@ingka/text';
import AdminTable from './AdminTable';
import { UserDetails } from '../../models/userDetailsType';
import useTranslation from '../../hooks/useTranslation';

type ProjectAdminPageProps = {
  userDetails: UserDetails[];
  review?: boolean;
};

const AdminPage: FC<ProjectAdminPageProps> = ({ userDetails, review }) => {
  const t = useTranslation();
  return (
    <Stack
      component="main"
      spacing={3}
      sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
    >
      <Stack direction="column" spacing={3}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          spacing={2}
        >
          <Text tagName="h1" textStyle="Heading.L">
            {t('admin.adminPage')}
          </Text>
          {
            // Removed for now.
          }
          {/* <Stack direction="row" alignItems="flex-end" spacing={1}>
            <FormControl>
              <InputLabel>Role</InputLabel>
              <Select
                sx={{ width: 150 }}
                value={role}
                label="Role"
                onChange={(e) => setRole(e.target.value)}
              >
                <MenuItem value={'Admin'}>Admin</MenuItem>
                <MenuItem value={'FM'}>FM</MenuItem>
                <MenuItem value={'OA'}>OA</MenuItem>
              </Select>
            </FormControl>
            <Button type="primary" href="/">
              View as role
            </Button>
          </Stack> */}
        </Stack>
      </Stack>
      <AdminTable userDetails={userDetails} review={review} />
    </Stack>
  );
};

export default AdminPage;
